// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3C-0A","text":"SelectPayment_text__N88cg","title":"SelectPayment_title__MptpX","btn":"SelectPayment_btn__1PpSM"};